import React, { Component } from "react";
import Sidebar from "./sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import IdleTimer from "react-idle-timer"; // npm i react-idle-timer
import "react-toastify/dist/ReactToastify.css";
import { TopBarComponent } from "./TopBarComponent";
import { SkeletonTheme } from "react-loading-skeleton";
import { trackLogout } from "../helpers/activityTracker";
import SosAlertCenter from "./sosAlert/SosAlertCenter";
export class AuthorisedLayout extends Component {
  static displayName = AuthorisedLayout.name;

  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.timeout = 3600000;
    this.toastId = React.createRef();
    this.state = {
      pageName:
        sessionStorage.getItem("PageName") === null
          ? "Dashboard"
          : sessionStorage.getItem("PageName"),
      alertsSettings: [],
      alertData: {},
      deviceObj: {},
      isReadable: false,
      vehicleList: [],
    };
  }

  componentDidMount() {
    window.authComponentUnloading = false;
    document.addEventListener("mousemove", this.handleMouseMove, false);
    document.addEventListener("keypress", this.handleKeyPress, false);
  }

  componentWillUnmount() {
    window.authComponentUnloading = true;
  }
  handleMouseMove = (event) => {
    if (this.state.isOpenAutoLogoutModal === true) {
      this.setState({ isOpenAutoLogoutModal: false });
      this.handleReset();
    }
  };
  handleKeyPress = (event) => {
    if (this.state.isOpenAutoLogoutModal === true) {
      this.setState({ isOpenAutoLogoutModal: false });
      this.handleReset();
    }
  };
  handleOnActive = async () => {
    this.setState({ lastEvent: "active" });
  };
  handleOnIdle = async (e) => {
    this.setState({ lastEvent: "idle" });
    trackLogout("Idle timeout");
    sessionStorage.clear();
    window.location.href = "/";
  };
  handleReset = async () => {
    this.idleTimer.reset();
  };
  handlePause = async () => {
    this.idleTimer.pause();
  };
  handleResume = async () => {
    this.idleTimer.resume();
  };

  render() {
    return (
      <SkeletonTheme>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          onActive={this.handleOnActive}
          onIdle={this.handleOnIdle}
          timeout={this.timeout}
          crossTab={{
            emitOnAllTabs: true,
          }}
        />
        <div className="main-wrapper">
          <Sidebar />
          <TopBarComponent
            pageName={sessionStorage.getItem("session_PageName")}
          />
          <div name="mainContent" className="main-content" style={{ background: "#FFF3E8", height: "100vh", overflowY: "auto" }}>
            <section className="section">{this.props.children}</section>
          </div>
        </div>
        <SosAlertCenter />
        <ToastContainer
          id={this.toastId.current}
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          style={{ width: "250px" }}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </SkeletonTheme>
    );
  }
}
